import { Box } from "@mui/material";
import { IconChartInfographic } from "@tabler/icons-react";
import { PropsWithChildren } from "react";
import { useSidebar } from "~/contexts/sidebar";
import { Navbar, Sidebar } from "./components";
import { DrawerHeader } from "./components/Sidebar/style";

export const drawerWidth = 270;

export type TSidebarItem = {
  text: string;
  icon: React.JSX.Element;
  path?: string;
  nested?: any[];
  collapsibleName?: string;
};

export const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const { isVisible, toggleSidebar } = useSidebar();

  const sidebarItems: TSidebarItem[] = [
    {
      text: "Dashboard",
      icon: <IconChartInfographic />,
      path: "/app/dashboard",
    },
  ];

  return (
    <Box sx={{ display: "flex" }}>
      <Navbar isDrawerOpen={isVisible} toggleDrawer={toggleSidebar} />
      <Sidebar
        toggleSidebar={toggleSidebar}
        sidebarItems={sidebarItems}
        isDrawerOpen={isVisible}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          padding: 0,
          backgroundColor: "#FAFAFA",
          minHeight: "100vh",
          height: "100%",
          width: "calc(100vw - 294px)",
        }}
      >
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
};
